import { apiRequest } from '../../fetchSetup';
import React, { useState, useEffect } from 'react';

import {
  Box, Container, Paper, Typography, Button, CircularProgress, Chip, Divider,
  IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Alert, Card,
  CardContent, Grid, TextField, Rating, MenuItem, Select, FormControl, InputLabel,
  Accordion, AccordionSummary, AccordionDetails,CardMedia
} from '@mui/material';
import {
  ArrowBack, Phone, Email, Description, Payment, LocationOn, ExpandMore,
  Person, Receipt, Inventory, RateReview, ReportProblem, Image as ImageIcon,Description as FileIcon, PictureAsPdf as PdfIcon
} from '@mui/icons-material';
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../../Components/Common/Footer"
import * as PaymentHandler from './PaymentHandler';
import CustomDialog from "../../CustomDialog";
import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";
import { styled } from "@mui/material/styles";
import TIME_SLOTS from "../../Configurations/timeslots.json";
import contactConfig from "../../Configurations/addressConfig.json";
import axios from 'axios';


const STATUS_COLORS = {
  pending: { bg: '#FEF3C7', bgDark: '#78350F', text: '#D97706', textDark: '#FCD34D', label: 'Pending' },
  confirmed: { bg: '#DBEAFE', bgDark: '#1E3A8A', text: '#2563EB', textDark: '#93C5FD', label: 'Confirmed' },
  dispatched: { bg: '#E0E7FF', bgDark: '#312E81', text: '#6366F1', textDark: '#C7D2FE', label: 'Dispatched' },
  delivered: { bg: '#D1FAE5', bgDark: '#064E3B', text: '#059669', textDark: '#6EE7B7', label: 'Delivered' },
  cancelled: { bg: '#FEE2E2', bgDark: '#7F1D1D', text: '#DC2626', textDark: '#FCA5A5', label: 'Cancelled' },
  awaiting_bill: { bg: '#FEF3C7', bgDark: '#78350F', text: '#D97706', textDark: '#FCD34D', label: 'Awaiting Bill' },
  bill_generated: { bg: '#DBEAFE', bgDark: '#1E3A8A', text: '#2563EB', textDark: '#93C5FD', label: 'Bill Generated' },
  in_progress: { bg: '#E0E7FF', bgDark: '#312E81', text: '#6366F1', textDark: '#C7D2FE', label: 'In Progress' },
  rescheduled: { bg: '#FEF3C7', bgDark: '#78350F', text: '#D97706', textDark: '#FCD34D', label: 'Rescheduled' },
  out_for_delivery: { bg: '#E0E7FF', bgDark: '#312E81', text: '#6366F1', textDark: '#C7D2FE', label: 'Out for Delivery' },
  completed: { bg: '#D1FAE5', bgDark: '#064E3B', text: '#059669', textDark: '#6EE7B7', label: 'Completed' },
  returned: {
  bg: '#FEE2E2',
  bgDark: '#7F1D1D',
  text: '#DC2626',
  textDark: '#FCA5A5',
  label: 'Returned'
},

partially_returned: {
  bg: '#FEF3C7',
  bgDark: '#78350F',
  text: '#D97706',
  textDark: '#FCD34D',
  label: 'Partially Returned'
},
};

const OrderDetailsScreen = () => {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [feedbackDialog, setFeedbackDialog] = useState(false);
  const [rescheduleDialog, setRescheduleDialog] = useState(false);
  const [complaintDialog, setComplaintDialog] = useState(false);
  const [cancelDialog, setCancelDialog] = useState(false);
  const [contactDialog, setContactDialog] = useState(false);
  const [reorderDialog, setReorderDialog] = useState(false);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [invoiceDialog,setInvoiceDialog]=useState(false)
  const [formData, setFormData] = useState({
    rating: 0,
    comment: "",
    category: "",
    date: "",
    reason: ""
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [expanded, setExpanded] = useState('items'); // Default expanded section
  const navigate = useNavigate();
  const location = useLocation();
  const { orderId } = location.state || {};
  const [dialog, setDialog] = useState({ open: false, message: "", type: "info", title: "Notification" });
  

  const [user, setUser] = useState(null);
  const [cancelReason, setCancelReason] = useState("");
  const [prescriptionFiles,setPrescriptionFiles]=useState([])

const [childOrders, setChildOrders] = useState([]);
const [hasChildren, setHasChildren] = useState(false);

const [reorderDeliveryTime, setReorderDeliveryTime] = useState("anytime");
const [reorderSelectedDate, setReorderSelectedDate] = useState("");
const [reorderSelectedSlot, setReorderSelectedSlot] = useState("");
const [reorderAvailableSlots, setReorderAvailableSlots] = useState([]);
const [reorderErrors, setReorderErrors] = useState({});
const { call, email } = contactConfig.support;
const [expandedIssues, setExpandedIssues] = useState({});
const PRESCRIPTION_LIST_API = process.env.REACT_APP_PRESCRITON_IMAGE_API_URL;
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;



  useEffect(() => {
    const loadUserData = async () => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) {
        setUser(null);
        return;
      }
      try {
        const userData = await fetchUserFromRedis(userId, token);
        console.log("User data loaded:", userData)
        setUser(userData || null);
      } catch (err) {
        console.error("Error fetching user from Redis:", err);
        setUser(null);
      }
    };
    loadUserData();
    fetchPrescriptionFiles(orderId);
  }, []);

  const ButtonStyle = styled(Button)(({ theme }) => ({
    borderColor: "#006D77",
    backgroundColor: "#22577A",
    color: "#fff",
    borderRadius: theme.shape.borderRadius * 1.5,
    fontWeight: 700,
    fontSize: 13,
    textTransform: "none",
    padding: theme.spacing(0.8, 2.5),
    "&:hover": {
      backgroundColor: "#57A0C8",
    },
  }));

  const paymentHandler = PaymentHandler.usePaymentHandler({
    userEmail: order?.user_email || '',
    userName: order?.delivery_address?.full_name || '',
    userPhone: order?.delivery_address?.phone || '',
    onSuccess: async (paymentData) => {
      console.log('✅ Payment successful, updating order...');
      try {
        await PaymentHandler.updateOrderPayment(orderId, paymentData);
        setDialogMessage('Payment successful! Your order is now confirmed.');
        setDialogOpen(true);
        fetchOrderDetails();
      } catch (error) {
        console.error('Failed to update order payment:', error);
        setDialogMessage('Payment received but failed to update order. Please contact support.');
        setDialogOpen(true);
      }
    },
    onFailure: (error) => {
      console.error('❌ Payment failed:', error);
      setDialogMessage(error.message || 'Payment failed. Please try again.');
      setDialogOpen(true);
    }
  });

  useEffect(() => {
    fetchOrderDetails();
  }, [orderId]);

const fetchChildOrders = async (parentOrderId) => {
  try {
    const endpoint = `${process.env.REACT_APP_CREATE_MEDICINE_ORDER}/${parentOrderId}/child-orders`;
    console.log("Fetching child orders from:", endpoint);
    const response = await apiRequest(endpoint);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    console.log("Child orders fetched:", data);
    
    if (data.child_orders && Array.isArray(data.child_orders)) {
      setChildOrders(data.child_orders);
    }
  } catch (error) {
    console.error("Error fetching child orders:", error);
  }
};
 const showDialog = (message, type = "info", title = "Notification") => {
    setDialog({ open: true, message, type, title });
  };


  const fetchOrderDetails = async () => {
    try {
      setLoading(true);
      const endpoint = `${process.env.REACT_APP_CREATE_MEDICINE_ORDER}/${orderId}`;
      console.log("Fetching order details from:", endpoint);
      const response = await apiRequest(endpoint);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Order details fetched:", data);
      setOrder(data);

      if (data.child_order_ids && data.child_order_ids.length > 0) {
        await fetchChildOrders(orderId);
        setHasChildren(true);
      } else {
        setChildOrders([]);
        setHasChildren(false);
      }

    } catch (error) {
      console.error("Error fetching order details:", error);
      setDialogMessage("Failed to load order details. Please try again.");
      setDialogOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleFeedbackSubmit = async () => {
    if (!formData.rating) {
      setDialogMessage("Please provide a rating");
      setDialogOpen(true);
      return;
    }
    try {
      setLoading(true);
      const response = await apiRequest(
        `${process.env.REACT_APP_CREATE_MEDICINE_ORDER}/${orderId}/feedback`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            rating: formData.rating,
            comment: formData.comment,
          }),
        }
      );
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.error || 'Failed to submit feedback');
      }
      setFeedbackDialog(false);
      setDialogMessage('Thank you for your feedback!');
      setDialogOpen(true);
      setFormData({ rating: 0, comment: "", category: "", date: "", reason: "" });
      fetchOrderDetails();
    } catch (error) {
      console.error('Error submitting feedback:', error);
      setDialogMessage(error.message || 'Failed to submit feedback');
      setDialogOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleComplaintSubmit = async () => {
    if (!formData.category || !formData.comment) {
      setDialogMessage("Please provide complaint category and description");
      setDialogOpen(true);
      return;
    }
    try {
      setLoading(true);
      const response = await apiRequest(
        `${process.env.REACT_APP_CREATE_MEDICINE_ORDER}/${orderId}/complaint`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            category: formData.category,
            description: formData.comment,
          }),
        }
      );
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.error || 'Failed to submit complaint');
      }
      setComplaintDialog(false);
      setDialogMessage('Complaint submitted successfully. Our team will review it shortly.');
      setDialogOpen(true);
      setFormData({ rating: 0, comment: "", category: "", date: "", reason: "" });
      fetchOrderDetails();
    } catch (error) {
      console.error('Error submitting complaint:', error);
      setDialogMessage(error.message || 'Failed to submit complaint');
      setDialogOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleRescheduleOrder = async () => {
    if (!formData.date) {
      setDialogMessage("Please select a new date and time");
      setDialogOpen(true);
      return;
    }
    try {
      setLoading(true);
      const response = await apiRequest(
        `${process.env.REACT_APP_CREATE_MEDICINE_ORDER}/${orderId}/reschedule`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            new_delivery_date: formData.date,
            reason: formData.reason || "User requested reschedule",
            notes: formData.comment || ""
          }),
        }
      );
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.error || 'Failed to reschedule order');
      }
      setRescheduleDialog(false);
      setDialogMessage('Order rescheduled successfully!');
      setDialogOpen(true);
      setFormData({ rating: 0, comment: "", category: "", date: "", reason: "" });
      fetchOrderDetails();
    } catch (error) {
      console.error('Error rescheduling order:', error);
      setDialogMessage(error.message || 'Failed to reschedule order');
      setDialogOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleReorderDateChange = (dateString) => {
    setReorderSelectedDate(dateString);
    setReorderSelectedSlot("");
    
    const selected = new Date(dateString);
    const now = new Date();
  
    const isToday =
      selected.getDate() === now.getDate() &&
      selected.getMonth() === now.getMonth() &&
      selected.getFullYear() === now.getFullYear();
  
    let slots;
    if (isToday) {
      const currentHour = now.getHours();
      slots = TIME_SLOTS.map((slot) => ({
        ...slot,
        disabled: currentHour >= slot.end
      }));
    } else {
      slots = TIME_SLOTS.map((slot) => ({ ...slot, disabled: false }));
    }
  
    setReorderAvailableSlots(slots);
  };


const handleInvoiceDownload=async(order_id)=>{
      try {
            const token = sessionStorage.getItem("token");

            const response = await axios.get(
              `${process.env.REACT_APP_API_INVOICE}/invoice/download/${order_id}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

          const download_url=response.data.download_url
            window.open(download_url, "_blank");

          } catch (error) {
            console.error("Invoice download failed:", error);
          }
}

  const handleReorderSubmit = async () => {
    if (reorderDeliveryTime === "specific") {
      if (!reorderSelectedDate) {
        setReorderErrors({ date: "Please select a delivery date" });
        setDialogMessage("Please select a delivery date");
        setDialogOpen(true);
        return;
      }
      if (!reorderSelectedSlot) {
        setReorderErrors({ time: "Please select a delivery time slot" });
        setDialogMessage("Please select a delivery time slot");
        setDialogOpen(true);
        return;
      }
    }
    try {
      setLoading(true);
      
      // Step 1: Check stock availability for all items
      const stockCheckPromises = order.items.map(async (item) => {
        try {
          
          const response = await apiRequest(
            `${process.env.REACT_APP_MEDICINE_API_URL}/check-stock`,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                medicine_name: item.medicine_name,
                quantity: item.quantity
              }),
            }
          );
          
          if (!response.ok) {
            throw new Error(`Failed to check stock for ${item.medicine_name}`);
          }
          
          const data = await response.json();
          
          return {
            medicine_name: item.medicine_name,
            requested_quantity: item.quantity,
            available: data.available || false,
            available_quantity: data.available_quantity || 0,
            in_stock: data.in_stock || false,
            message: data.message || ''
          };
        } catch (error) {
          console.error(`Error checking stock for ${item.medicine_name}:`, error);
          return {
            medicine_name: item.medicine_name,
            requested_quantity: item.quantity,
            available: false,
            available_quantity: 0,
            in_stock: false,
            message: error.message
          };
        }
      });
  
      const stockResults = await Promise.all(stockCheckPromises);
      
      // Check if any items are unavailable
      const unavailableItems = stockResults.filter(result => !result.available);
      // If there are unavailable items, show detailed error message
      if (unavailableItems.length > 0) {
        let errorMessage = "Unable to complete reorder:\n\n";
        
        unavailableItems.forEach(item => {
          if (!item.in_stock) {
            errorMessage += ` ${item.medicine_name} - OUT OF STOCK\n`;
          } else {
            errorMessage += ` ${item.medicine_name} - Insufficient quantity\n`;
            errorMessage += `   Requested: ${item.requested_quantity}, Available: ${item.available_quantity}\n`;
          }
        });
        
        errorMessage += "\nPlease create a new order with available items or adjust quantities.";
        
        setReorderDialog(false);
        setDialogMessage(errorMessage);
        setDialogOpen(true);
        setLoading(false);
        return;
      }

        let deliveryTimeData;
        let deliveryDateData = null;

        if (reorderDeliveryTime === "anytime") {
          deliveryTimeData = "Anytime";
        } else {
          // Format: "2024-01-15 | 09:00 AM - 12:00 PM"
          deliveryTimeData = `${reorderSelectedDate} | ${reorderSelectedSlot}`;
          deliveryDateData = reorderSelectedDate;
        }

        // Step 2: All items are available, proceed with reorder
        const response = await apiRequest(
          `${process.env.REACT_APP_CREATE_MEDICINE_ORDER}/${orderId}/reorder`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              payment: {
                method: "online",
                status: "pending"
              },
              stock_verified: true,
              stock_results: stockResults,
              // Delivery time fields
              delivery_time: deliveryTimeData,
              delivery_time_option: reorderDeliveryTime,
              delivery_date: deliveryDateData,
              delivery_slot: reorderDeliveryTime === "specific" ? reorderSelectedSlot : null,
              // Include delivery address from original order
              delivery_address: {
                ...order.delivery_address,
                delivery_time: deliveryTimeData,
                delivery_time_option: reorderDeliveryTime
              }
            }),
          }
        );
      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.error || 'Failed to create reorder');
      }
      
      setReorderDialog(false);
      
      let successMessage = ' Order placed successfully!';
      if (result.warning) {
        successMessage += `\n\n Note: ${result.warning}`;
      }
      // Show delivery time confirmation
      if (reorderDeliveryTime === "specific" && reorderSelectedDate && reorderSelectedSlot) {
        successMessage += `\n\n Scheduled for: ${reorderSelectedDate} | ${reorderSelectedSlot}`;
      } else {
        successMessage += `\n\n Delivery: Anytime`;
      }
      setDialogMessage(successMessage);
      setDialogOpen(true);


      // Reset reorder state
      setReorderDeliveryTime("anytime");
      setReorderSelectedDate("");
      setReorderSelectedSlot("");
      setReorderAvailableSlots([]);
      setReorderErrors({});


      // Navigate to new order after short delay
      setTimeout(() => {
        navigate('/order-details', { state: { orderId: result.order_id } });
      }, 1500);
      setReorderDeliveryTime("anytime");
      setReorderSelectedDate("");
      setReorderSelectedSlot("");
      setReorderAvailableSlots([]);
      setReorderErrors({});
    } catch (error) {
      console.error('Error creating reorder:', error);
      setReorderDialog(false);
      setDialogMessage(
        error.message || 'Failed to create reorder. Please try again.'
      );
      setDialogOpen(true);
    } finally {
      setLoading(false);
    }
  };

 const fetchPrescriptionFiles = async (orderId, reorderFrom = null) => {
    try {
      const orderIdToFetch = reorderFrom || orderId;
      const res = await apiRequest(`${PRESCRIPTION_LIST_API}/${orderIdToFetch}`);
      const data = await res.json();
      if (data.success && data.files) {
        setPrescriptionFiles(data.files);
        return data.files;
      }
      setPrescriptionFiles([]);
      return [];
    } catch (error) {
      showDialog("Failed to load prescription files", "error", "Error");
      setPrescriptionFiles([]);
      return [];
    }
  };
  const handleRetryPayment = async () => {
    if (!order || paymentProcessing) return;
    try {
      setPaymentProcessing(true);
      await paymentHandler.processOnlinePayment({
        amount: order.total_amount,
        orderType: order.order_type,
        description: `Payment for Order #${order.order_id}`,
        metadata: {
          order_id: orderId,
          retry_payment: "true"
        }
      });
    } catch (error) {
      console.error('Payment retry error:', error);
      if (error.message !== 'Payment cancelled by user') {
        setDialogMessage(error.message || 'Payment failed. Please try again.');
        setDialogOpen(true);
      }
    } finally {
      setPaymentProcessing(false);
    }
  };

  const handleCancelOrder = async () => {
    try {
      setLoading(true);
      const response = await apiRequest(
        `${process.env.REACT_APP_CREATE_MEDICINE_ORDER}/${orderId}/cancel`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            cancellation_reason: cancelReason,
          }),
        }
      );
      const result = await response.json();
      if (!response.ok) {
        throw new Error(result.error || 'Failed to cancel order');
      }
      setCancelDialog(false);
      setDialogMessage(result.refund_message || 'Order cancelled successfully!');
      setDialogOpen(true);
      fetchOrderDetails();
    } catch (error) {
      console.error('Error cancelling order:', error);
      setDialogMessage(error.message || 'Failed to cancel order');
      setDialogOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    return STATUS_COLORS[status] || STATUS_COLORS.pending;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  };

const getCombinedIssues = (order) => {
  if (!order) return [];
  
  const issues = [];
  
  // Medicine orders ONLY have delivery_issues (no collection_failures)
  if (order.delivery_issues && order.delivery_issues.length > 0) {
    order.delivery_issues.forEach(issue => {
      issues.push({
        ...issue,
        source: 'delivery_issue',
        issue_category: 'Delivery Issue'
      });
    });
  }
  issues.sort((a, b) => {
    const dateA = new Date(a.reported_at);
    const dateB = new Date(b.reported_at);
    return dateB - dateA;
  });
  
  return issues;
};
const renderIssuesSection = () => {
  const combinedIssues = getCombinedIssues(order);
  
  if (combinedIssues.length === 0) return null;
  
  return (

          <Accordion
      expanded={expanded === 'issues'}
      onChange={handleAccordionChange('issues')}
            sx={{ mb: 2, borderRadius: '12px !important', boxShadow: '0 2px 8px rgba(34, 87, 122, 0.1)', '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              sx={{ bgcolor: '#F8FAFC', borderBottom: expanded === 'delivery' ? '1px solid #E2E8F0' : 'none', '&:hover': { bgcolor: '#EFF6FF' }, minHeight: '64px' }}
            >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
          <ReportProblem sx={{fontSize: 28, color: '#22577A'  }} />
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" fontWeight="bold" sx={{ color: '#22577A' }}>
            Delivery Issues</Typography>

            <Typography variant="caption" color="text.secondary">
              {combinedIssues.length} issue(s) reported
            </Typography>
          </Box>
          <Chip 
            label={`${combinedIssues.filter(i => i.status === 'open').length} Active`}
            size="small"
            sx={{ fontWeight: 600,fontSize: 11,pointerEvents: 'none'}}
          />
        </Box>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {combinedIssues.map((issue, index) => {
            const isExpanded = expandedIssues[issue.issue_id] || false;
            const issueTypeFormatted = issue.issue_type?.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase()) || 'N/A';
            
            return (
              <Card 
                key={issue.issue_id || index}
                elevation={2}
                sx={{ bgcolor: 'white',overflow: 'hidden'}}
              >
                {/* Issue Header */}
                <Box
                  onClick={() => setExpandedIssues(prev => ({ ...prev, [issue.issue_id]: !isExpanded }))}
                  sx={{p: 2,display: 'flex',justifyContent: 'space-between',alignItems: 'center',cursor: 'pointer',transition: 'all 0.2s',
                    '&:hover': { bgcolor:'#EFF6FF' }
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5, flexWrap: 'wrap' }}>
                      {/* Status Dot */}
                      <Box
                  sx={{width: 8,height: 8,borderRadius: '50%',bgcolor:  '#006D77',boxShadow: `0 0 0 3px ${'#D1EEF0'}`}}
                      />
                      
                      <Typography variant="body2" fontWeight="700" color="#111827" sx={{ fontSize: 14 }}>
                        {issue.issue_id}
                      </Typography>
                      
                      <Chip 
                        label={issueTypeFormatted}
                        size="small"
                        sx={{ bgcolor: '#F3F4F6',color: '#374151',fontWeight: 600,fontSize: '0.70rem',height: 20 }}
                      />
                      
                      <Chip 
                        label={issue.status === 'resolved' ? 'Resolved' : issue.status === 'in_progress' ? 'In Progress' : 'Open'}
                        size="small"
                        color={
                          issue.status === 'resolved' ? 'success' :
                          issue.status === 'in_progress' ? 'warning' :
                          'error'
                        }
                        sx={{ fontWeight: 600,fontSize: 11,height: 22,pointerEvents: 'none' }}
                      />
                    </Box>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11 }}>
                      Reported {formatDate(issue.reported_at)} • By {issue.reported_by || 'System'}
                    </Typography>
                  </Box>

                  <IconButton size="small">
                    <Box
                      sx={{transform: isExpanded ? 'rotate(45deg)' : 'rotate(0deg)',transition: 'transform 0.2s',fontSize: 20,fontWeight: 'bold',color: '#64748B' }}
                    >
                      ✕
                    </Box>
                  </IconButton>
                </Box>

                {/* Expandable Details */}
                {isExpanded && (
                  <Box sx={{ p: 3, pt: 0, borderTop: '2px solid #E5E7EB', bgcolor: '#F9FAFB' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                      {/* Description */}
                      <Box>
                        <Typography variant="caption" color="text.secondary" fontWeight="700" sx={{ fontSize: 11, display: 'block', mb: 0.5 }}>
                          Issue Description
                        </Typography>
                        <Paper variant="outlined" sx={{ p: 2, bgcolor: 'white' }}>
                          <Typography variant="body2" color="#4B5563" sx={{ fontSize: 13 }}>
                            {issue.description || 'No description provided'}
                          </Typography>
                        </Paper>
                      </Box>

                      {/* Issue Details Grid */}
                      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
                        <Paper variant="outlined" sx={{ p: 1.5, bgcolor: 'white' }}>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
                            Issue Type
                          </Typography>
                          <Typography variant="body2" fontWeight="600" sx={{ fontSize: 12 }}>
                            {issueTypeFormatted}
                          </Typography>
                        </Paper>
                        
                        <Paper variant="outlined" sx={{ p: 1.5, bgcolor: 'white' }}>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
                            Status
                          </Typography>
                          <Typography variant="body2" fontWeight="600" sx={{ fontSize: 12 }}>
                            {issue.status === 'resolved' ? 'Resolved' : issue.status === 'in_progress' ? 'In Progress' : 'Open'}
                          </Typography>
                        </Paper>
                        
                        <Paper variant="outlined" sx={{ p: 1.5, bgcolor: 'white' }}>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
                            Reported By
                          </Typography>
                          <Typography variant="body2" fontWeight="600" sx={{ fontSize: 12 }}>
                            {issue.reported_by || 'Unknown'}
                          </Typography>
                        </Paper>
                        
                        <Paper variant="outlined" sx={{ p: 1.5, bgcolor: 'white' }}>
                          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
                            Reported At
                          </Typography>
                          <Typography variant="body2" fontWeight="600" sx={{ fontSize: 12 }}>
                            {formatDate(issue.reported_at)}
                          </Typography>
                        </Paper>
                      </Box>

                      {/* Photo Evidence */}
                      {issue.photo_url && (
                        <Box>
                          <Typography variant="caption" color="text.secondary" fontWeight="700" sx={{ fontSize: 11, display: 'block', mb: 0.5 }}>
                            Photo Evidence
                          </Typography>
                          <Paper
                            elevation={3}
                            sx={{overflow: 'hidden',borderRadius: 2,cursor: 'pointer',position: 'relative',
                              '&:hover': { transform: 'scale(1.02)', transition: 'transform 0.3s' }
                            }}
                            onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL}${issue.photo_url}`, '_blank')}
                          >
                            <Box
                              component="img"
                              src={`${process.env.REACT_APP_BACKEND_URL}${issue.photo_url}`}
                              alt="Issue evidence"
                              sx={{width: '100%',height: 200,objectFit: 'cover'}}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                            <Box
                              sx={{position: 'absolute',bottom: 0,left: 0,right: 0,bgcolor: 'rgba(0,0,0,0.7)',color: 'white',p: 1,textAlign: 'center'}}
                            >
                              <Typography variant="caption" sx={{ fontSize: 11 }}>
                                🔍 Click to view full size
                              </Typography>
                            </Box>
                          </Paper>
                        </Box>
                      )}

                      {/* Resolution (if resolved) */}
                      {issue.status === 'resolved' && issue.resolution && (
                        <Box>
                          <Typography variant="caption" color="#059669" fontWeight="700" sx={{ fontSize: 11, display: 'block', mb: 0.5 }}>
                            ✅ Resolution
                          </Typography>
                          <Paper 
                            variant="outlined"
                            sx={{ 
                              p: 2, 
                              bgcolor: '#F0FDF4',
                              borderColor: '#86EFAC'
                            }}
                          >
                            <Typography variant="body2" color="#166534" sx={{ fontSize: 13 }}>
                              {issue.resolution}
                            </Typography>
                            {issue.resolved_by && issue.resolved_at && (
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1, fontSize: 10 }}>
                                Resolved by {issue.resolved_by} on {formatDate(issue.resolved_at)}
                              </Typography>
                            )}
                          </Paper>
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}
              </Card>
            );
          })}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
  const renderPaymentAlert = () => {
    if (!order) return null;
    const isCancelled = order.order_status === "cancelled";
    const isPaymentPending = order.payment.status === 'pending' || order.payment.status === 'failed';
    const isOnlinePayment = order.payment.method === 'online';
    if (isCancelled) return null;
    if (isPaymentPending && isOnlinePayment) {
      return (
        <Alert
          severity="warning"
          sx={{ mb: 3 }}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={handleRetryPayment}
              disabled={paymentProcessing || !paymentHandler.razorpayLoaded}
            >
              {paymentProcessing ? 'Processing...' : 'Retry Payment'}
            </Button>
          }
        >
          <Typography fontWeight="bold">Payment Pending</Typography>
          <Typography variant="body2">
            Complete your payment to confirm this order. Click "Retry Payment" to continue.
          </Typography>
        </Alert>
      );
    }
    return null;
  };
  
const renderChildOrders = () => {
  if (!hasChildren || childOrders.length === 0) {
    return null;
  }
  return (
    <Box sx={{ mb: 3 }}>
      <Typography 
        variant="h6" 
        fontWeight="bold" 
        sx={{ mb: 2, color: '#22577A',display: 'flex',alignItems: 'center',gap: 1 }}
      >
        <Box
          component="span"
          sx={{bgcolor: '#F8FAFC',color: 'white',
            fontSize: 11,fontWeight: 700,px: 1.5,py: 0.5,borderRadius: 1,
          }}
        >
          SPLIT ORDER
        </Box>
        Sub-Orders ({childOrders.length})
      </Typography>

      {childOrders.map((childOrder, index) => (
        <Accordion
          key={childOrder.order_id}
          sx={{ 
            mb: 2, 
            borderRadius: '12px !important', 
            boxShadow: '0 2px 8px rgba(245, 158, 11, 0.2)',
            '&:before': { display: 'none' } 
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore />}
            sx={{ 
              '&:hover': { bgcolor: '#EFF6FF' },
              minHeight: '64px' 
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
              <Box sx={{ flex: 1 }}>
                <Typography variant="h6" fontWeight="bold" sx={{ color: '#006D77' }}>
                  {childOrder.order_id}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {childOrder.items?.length || 0} items • ₹{childOrder.total_amount?.toFixed(2)}
                </Typography>
              </Box>
              <Chip
                label={STATUS_COLORS[childOrder.order_status]?.label || 'Pending'}
                sx={{
                  bgcolor: STATUS_COLORS[childOrder.order_status]?.bg || STATUS_COLORS.pending.bg,
                  color: STATUS_COLORS[childOrder.order_status]?.text || STATUS_COLORS.pending.text,
                  fontWeight: 600,
                  fontSize: 12,
                  pointerEvents: 'none'
                }}
              />
            </Box>
          </AccordionSummary>
          
          <AccordionDetails sx={{ p: 3,}}>
            {/* Child Order Items */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 2, }}>
                Items in this sub-order:
              </Typography>
              
              <Box sx={{ 
                display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 2, pb: 2, mb: 2, 
                borderBottom: '2px solid #006D77', fontWeight: 700, fontSize: '0.875rem', color: '#006D77' 
              }}>
                <Typography fontSize="inherit" fontWeight="inherit">Item</Typography>
                <Typography fontSize="inherit" fontWeight="inherit" textAlign="center">Price</Typography>
                <Typography fontSize="inherit" fontWeight="inherit" textAlign="center">Qty</Typography>
                <Typography fontSize="inherit" fontWeight="inherit" textAlign="right">Total</Typography>
              </Box>

              {childOrder.items && childOrder.items.length > 0 ? (
                childOrder.items.map((item, itemIndex) => (
                  <Box
                    key={itemIndex}
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: '2fr 1fr 1fr 1fr',gap: 2,py: 2,px: 1.5,mb: 1,
                      borderRadius: 2,
                      bgcolor: itemIndex % 2 === 0 ? '#F8FAFC' : 'transparent',
                      alignItems: 'center'
                    }}
                  >
                    <Typography fontWeight="600" fontSize="0.95rem" >
                      {item.medicine_name}
                    </Typography>
                    <Typography fontWeight="600" fontSize="0.9rem" textAlign="center">
                      ₹{Number(item.price).toFixed(2)}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Chip
                        label={`×${item.quantity}`}
                        size="small"
                        sx={{ bgcolor: '#DBEAFE',color: '#1E40AF',fontWeight: 700,fontSize: '0.8rem',pointerEvents: 'none'
                        }}
                      />
                    </Box>
                    <Typography fontWeight="700" fontSize="1rem"  textAlign="right">
                      ₹{Number(item.total_price).toFixed(2)}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography color="text.secondary" sx={{ textAlign: 'center', py: 2 }}>
                  No items found
                </Typography>
              )}
            </Box>

            {/* Child Order Totals */}
            <Box sx={{  mt: 2, p: 2,bgcolor: '#F8FAFC', borderRadius: 2,border: '1px solid #F8FAFC'
            }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography variant="body2" >Subtotal:</Typography>
                <Typography variant="body2" fontWeight="600" >
                  ₹{childOrder.subtotal?.toFixed(2)}
                </Typography>
              </Box>
              
              {childOrder.delivery_charge > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2" >Delivery Charge:</Typography>
                  <Typography variant="body2" fontWeight="600" >
                    ₹{childOrder.delivery_charge?.toFixed(2)}
                  </Typography>
                </Box>
              )}
              
              {childOrder.discount > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2" >Discount:</Typography>
                  <Typography variant="body2" fontWeight="600">
                    -₹{childOrder.discount?.toFixed(2)}
                  </Typography>
                </Box>
              )}
              
              <Divider sx={{ my: 1, bgcolor: '#F8FAFC' }} />
              
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="body1" fontWeight="700">Total:</Typography>
                <Box sx={{ 
                  color: '#fff', 
                  fontSize: 14, 
                  fontWeight: 700, 
                  px: 2, 
                  py: 0.5, 
                  borderRadius: 2 
                }}>
                  ₹{childOrder.total_amount?.toFixed(2)}
                </Box>
              </Box>
            </Box>

            {/* Payment Status */}
            <Box sx={{ mt: 2, p: 1.5, bgcolor: '#F8FAFC', borderRadius: 1, border: '1px solid #F8FAFC' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" fontWeight="600" >
                  Payment Status:
                </Typography>
                <Chip
                  label={childOrder.payment?.status === 'success' ? 'Paid' : childOrder.payment?.status === 'failed' ? 'Failed' : 'Pending'}
                  size="small"
                  sx={{
                    bgcolor: childOrder.payment?.status === 'success' ? '#D1FAE5' : childOrder.payment?.status === 'failed' ? '#FEE2E2' : '#FEF3C7',
                    color: childOrder.payment?.status === 'success' ? '#059669' : childOrder.payment?.status === 'failed' ? '#DC2626' : '#D97706',
                    fontWeight: 'bold',
                    pointerEvents: 'none'
                  }}
                />
              </Box>
            </Box>

            {/* Child Order Notes */}
            {childOrder.notes && (
              <Box sx={{ mt: 2, p: 1.5, bgcolor: '#F8FAFC', borderRadius: 1, border: '1px solid #F8FAFC' }}>
                <Typography variant="caption" fontWeight="600"  sx={{ display: 'block', mb: 0.5 }}>
                  Notes:
                </Typography>
                <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                  {childOrder.notes}
                </Typography>
              </Box>
            )}
          </AccordionDetails>
        </Accordion>
      ))}

      {/* Summary Alert */}
      <Alert severity="info" sx={{ mt: 2 }}>
        <Typography variant="body2" fontWeight="600" sx={{ mb: 0.5 }}>
          Split Order Information
        </Typography>
        <Typography variant="caption">
          This order was split into {childOrders.length + 1} parts. The main order contains {order.items?.length || 0} items, 
          and there {childOrders.length === 1 ? 'is 1 sub-order' : `are ${childOrders.length} sub-orders`} with additional items 
          that will be delivered separately.
        </Typography>
      </Alert>
    </Box>
  );
};


  const renderDeliveryTimeline = () => {
    const isCancelled = order.order_status === "cancelled";
    if (isCancelled) {
      return (
        <Card sx={{ mb: 3, bgcolor: "#FEE2E2", borderRadius: 3, boxShadow: "0 1px 4px rgba(0,0,0,0.05)" }}>
          <CardContent sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="h3" sx={{ mb: 2 }}>❌</Typography>
            <Typography variant="h6" color="#DC2626" fontWeight="bold" sx={{ mb: 1 }}>
              Order Cancelled
            </Typography>
            {order.cancellation_info?.reason && (
              <Typography color="#7F1D1D" sx={{ mt: 1 }}>
                Reason: {order.cancellation_info.reason}
              </Typography>
            )}
          </CardContent>
        </Card>
      );
    }
    // const DELIVERY_STEPS = DELIVERY_STEPS_MAP[order.order_status];
    const DELIVERY_STEPS = [
      { id: 'pending', label: 'Order Placed', icon: '📦' },
      { id: 'dispatched', label: 'Dispatched', icon: '📤' },
      { id: 'out_for_delivery', label: 'Out for Delivery', icon: '🚚' },
      { id: 'delivered', label: 'Delivered', icon: '🎉' },
    ];
    const STATUS_TO_STEP_INDEX = {
      pending: 0,
      confirmed: 0,
    
      dispatched: 1,
      in_progress: 1,
      rescheduled: 1,
    
      out_for_delivery: 2,
    
      delivered: 3,
      completed: 3,
    };
    
    // const currentStep = DELIVERY_STEPS.findIndex(step => step.id === order.order_status);
    const currentStep = STATUS_TO_STEP_INDEX[order.order_status] ?? 0;

    return (
      <Paper sx={{ p: 3, mb: 3, borderRadius: 3, boxShadow: "0 1px 6px rgba(0,0,0,0.08)" }}>
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: "#22577A", fontSize: 24 }}>
          Delivery Timeline
        </Typography>
        <Box sx={{ position: "relative", mb: 4, mt: 1 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", mb: 2 }}>
            {DELIVERY_STEPS.map((step, index) => (
              <Typography
                key={step.id}
                sx={{
                  fontSize: 13,
                  fontWeight: index <= currentStep ? 700 : 500,
                  color: index <= currentStep ? "#111827" : "#9CA3AF",
                  width: `${100 / DELIVERY_STEPS.length}%`,
                  textAlign: index === 0 ? "left" : index === DELIVERY_STEPS.length - 1 ? "right" : "center",
                }}
              >
                {step.label}
              </Typography>
            ))}
          </Box>
          <Box sx={{ position: "relative", display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
            <Box sx={{ position: "absolute", top: "50%", left: 0, width: "100%", height: 2, bgcolor: "#E5E7EB", transform: "translateY(-50%)", zIndex: 0 }} />
            <Box sx={{ position: "absolute", top: "50%", left: 0, width: `${(currentStep / (DELIVERY_STEPS.length - 1)) * 100}%`, height: 2, bgcolor: "#22577A", transform: "translateY(-50%)", zIndex: 1, transition: "width 0.4s ease" }} />
            {DELIVERY_STEPS.map((step, index) => (
              <Box
                key={step.id}
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  bgcolor: index <= currentStep ? "#22577A" : "#E5E7EB",
                  color: "#fff",
                  zIndex: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 12,
                  fontWeight: "bold",
                }}
              >
                {index <= currentStep ? step.icon : ""}
              </Box>
            ))}
          </Box>
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: "left", fontWeight: 500 }}>
          {DELIVERY_STEPS[currentStep]?.label ? `${DELIVERY_STEPS[currentStep].label} - In Progress` : "In Progress"}
        </Typography>
      </Paper>
    );
  };
    const getFileType = (url) => {
    if (!url) return "unknown";
    const extension = url.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp", "svg"].includes(extension)) return "image";
    if (extension === "pdf") return "pdf";
    if (["doc", "docx"].includes(extension)) return "document";
    return "unknown";
  };
    const getFileUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    if (url.startsWith("/prescriptions/")) return `${BACKEND_URL}/api/flask/prescription${url}`;
    const cleanUrl = url.startsWith("/") ? url : `/${url}`;
    return `${BACKEND_URL}/api/flask/prescription/prescriptions${cleanUrl}`;
  };
    const getFileIcon = (fileType) => {
      switch (fileType) {
        case "image":    return <ImageIcon />;
        case "pdf":      return <PdfIcon />;
        case "document": return <FileIcon />;
        default:         return <FileIcon />;
      }
    };
      const openFileDialog = (fileUrl) => {
    let fullUrl;
    if (fileUrl.startsWith("/prescriptions/")) {
      fullUrl = `${BACKEND_URL}/api/flask/prescription${fileUrl}`;
    } else {
      const cleanUrl = fileUrl.startsWith("/") ? fileUrl : `/${fileUrl}`;
      fullUrl = `${BACKEND_URL}/api/flask/prescription/prescriptions${cleanUrl}`;
    }

  };

  
    const FilePreview = ({ file, onClick }) => {
      const fileType = getFileType(file.url);
      const fileUrl = getFileUrl(file.url);
      return (
        <Card elevation={2} sx={{ cursor: "pointer", transition: "all 0.2s", "&:hover": { transform: "scale(1.05)", boxShadow: 6 } }} onClick={onClick}>
          {fileType === "image" ? (
            <CardMedia component="img" height="200" image={fileUrl} alt={file.filename || "Prescription"} sx={{ objectFit: "contain", bgcolor: "#f8fafc" }}
              onError={(e) => { e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><text x="50%" y="50%" text-anchor="middle" fill="%23999">Image not found</text></svg>'; }} />
          ) : (
            <Box sx={{ height: 200, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", bgcolor: "#f8fafc", gap: 2 }}>
              <Box sx={{ fontSize: 60, color: "#006D77" }}>{getFileIcon(fileType)}</Box>
              <Typography sx={{ fontSize: 14, color: "#64748b", fontWeight: 600 }}>{fileType.toUpperCase()} File</Typography>
            </Box>
          )}
          <CardContent sx={{ py: 1, textAlign: "center" }}>
            <Typography sx={{ fontSize: 12, color: "#64748b", display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
              {getFileIcon(fileType)} {file.filename || `File ${fileType}`}
            </Typography>
            <Typography sx={{ fontSize: 10, color: "#94a3b8" }}>Click to {fileType === "image" || fileType === "pdf" ? "view" : "download"}</Typography>
          </CardContent>
        </Card>
      );
    };
  const formatTimeToIso=(time)=>{
    if (time!=="" && time!=="Anytime"){
      const istTime = new Date(time)
      .toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        dateStyle: "medium",
        timeStyle: "short"
      });
        return istTime
      }
    else return "Anytime"
}

  const getActionButtons = () => {
    const status = order.order_status;
    const paymentCompleted = order.payment?.status === "success";
    const buttons = {
      payNow: {
        show: !paymentCompleted,
        label: paymentProcessing ? "Processing..." : "💳 Pay Now",
        variant: "contained",
        onClick: handleRetryPayment,
        disabled: paymentProcessing || !paymentHandler?.razorpayLoaded,
      },
      complaint: {
        show: true,
        label: "Complaint",
        variant: "outlined",
        onClick: () => setComplaintDialog(true),
      },
      feedback: {
        show: true,
        label: "Feedback",
        variant: "contained",
        onClick: () => setFeedbackDialog(true),
      },
      invoice: {
        show: true,
        label: "Download Invoice",
        variant: "contained",
        onClick: () => handleInvoiceDownload(order.order_id),
      },
      reorder: {
        show: true,
        label: "Reorder",
        variant: "outlined",
        onClick: () => setReorderDialog(true),
      },
      support: {
        show: true,
        label: "Support",
        variant: "text",
        onClick: () => setContactDialog(true),
      },
      cancel: {
        show: true,
        label: "Cancel",
        variant: "outlined",
        color: "error",
        onClick: () => setCancelDialog(true),
        sx: {
          borderColor: "red",
          bgcolor: "red",
          color: "#fff",
          borderRadius: 1.5,
          fontWeight: 700,
          fontSize: 13,
          textTransform: "none",
          px: 2.5,
          "&:hover": { bgcolor: "#E57373" },
        },
      },
    };
    const statusButtonMap = {
      awaiting_bill: ['payNow', 'complaint', 'cancel', 'support','invoice'],
      bill_generated: ['payNow', 'complaint', 'cancel', 'support','invoice'],
      confirmed: ['payNow', 'complaint', 'cancel', 'support','invoice'],
      in_progress: ['payNow', 'complaint', 'cancel', 'support','invoice'],
      rescheduled: ['payNow', 'complaint', 'cancel', 'support','invoice'],
      dispatched: ['payNow', 'complaint', 'support','invoice'],
      out_for_delivery: ['payNow', 'complaint', 'support','invoice'],
      delivered: ['complaint', 'feedback', 'reorder', 'support','invoice'],
      cancelled: ['reorder', 'support'],
    };
    const buttonKeys = statusButtonMap[status] || [];
    return buttonKeys.map(key => buttons[key]).filter(btn => btn && btn.show);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress size={60} sx={{ color: '#006D77' }} />
          <Typography sx={{ mt: 2, color: '#6B7280' }}>Loading please wait...</Typography>
        </Box>
      </Box>
    );
  }

  if (!order) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Box sx={{ textAlign: 'center', p: 4 }}>
          <Typography variant="h2" sx={{ mb: 2 }}>😕</Typography>
          <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>Order Not Found</Typography>
          <Button variant="contained" sx={{ bgcolor: '#006D77' }} onClick={() => navigate(-1)}>Go Back</Button>
        </Box>
      </Box>
    );
  }


  return (
    <Box sx={{ bgcolor: '#F9FAFB', minHeight: '100vh', pb: 10 }}>
      <Paper sx={{ p: 2, mb: 3, borderRadius: 5 }}>
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton onClick={() => navigate(-1)} sx={{ p: 1 }}>
                <ArrowBack />
              </IconButton>
              <Typography variant="h5" fontWeight="bold">Order Details</Typography>
            </Box>
            <IconButton onClick={() => setContactDialog(true)}>
              <HeadsetMicIcon sx={{ fontSize: 30, color: "#006D77" }} />
            </IconButton>
          </Box>
        </Container>
      </Paper>

      <Container maxWidth="lg">
        {renderPaymentAlert()}

        {/* Order Header */}
        <Paper sx={{ p: 3, mb: 3, borderRadius: 3, boxShadow: "0 2px 8px rgba(34, 87, 122, 0.2)" }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
            <Box>
              <Typography sx={{ fontSize: 24, color: "#062126", fontWeight: 600 }}>{order.order_id}</Typography>
              <Typography variant="caption" color="text.primary">Placed on {formatDate(order.created_at)}</Typography>
            </Box>
            <Chip
              onClick={(e) => {
                  e.stopPropagation(); // prevent parent click
                }}
              label={
                order.order_type === 'prescription' && order.order_status === 'awaiting_bill'
                  ? STATUS_COLORS.awaiting_bill.label
                  : order.order_type === 'pharmacy' && order.order_status === 'awaiting_bill'
                  ? STATUS_COLORS.pending.label
                  : STATUS_COLORS[order.order_status]?.label || STATUS_COLORS.pending.label
              }
              sx={{
                backgroundColor: 
                  order.order_type === 'prescription' && order.order_status === 'awaiting_bill'
                    ? STATUS_COLORS.awaiting_bill.bg
                    : order.order_type === 'pharmacy' && order.order_status === 'awaiting_bill'
                    ? STATUS_COLORS.pending.bg
                    : STATUS_COLORS[order.order_status]?.bg || STATUS_COLORS.pending.bg,
                color:
                  order.order_type === 'prescription' && order.order_status === 'awaiting_bill'
                    ? STATUS_COLORS.awaiting_bill.text
                    : order.order_type === 'pharmacy' && order.order_status === 'awaiting_bill'
                    ? STATUS_COLORS.pending.text
                    : STATUS_COLORS[order.order_status]?.text || STATUS_COLORS.pending.text,
                fontWeight: 600,
                pointerEvents: 'none',
              }}
            />

          </Box>
          {order.order_type === 'prescription' && order.prescription_url && (
            <Alert icon={<Description />} severity="info" sx={{ mt: 2 }}>
              <Typography fontWeight="bold">Prescription Order</Typography>
              <Typography variant="caption">{order.prescription_verified ? '✅ Verified' : '⏳ Pending Verification'}</Typography>
            </Alert>
          )}
        </Paper>

        {/* Delivery Timeline */}
        {renderDeliveryTimeline()}

        {/* Accordion Sections */}
        <Box sx={{ mb: 3 }}>
           {/* Order Summary Accordion */}
           <Accordion
            expanded={expanded === 'items'}
            onChange={handleAccordionChange('items')}
            sx={{ mb: 2, borderRadius: '12px !important', boxShadow: '0 2px 8px rgba(34, 87, 122, 0.1)', '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              sx={{ bgcolor: '#F8FAFC', borderBottom: expanded === 'items' ? '1px solid #E2E8F0' : 'none', '&:hover': { bgcolor: '#EFF6FF' }, minHeight: '64px' }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Inventory sx={{ color: '#22577A', fontSize: 28 }} />
                <Box>
                  <Typography variant="h6" fontWeight="bold" sx={{ color: '#22577A' }}>Order Summary</Typography>
                  <Typography variant="caption" color="text.secondary">{order.items?.length || 0} items</Typography>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 3 }}>
              <Box sx={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr', gap: 1, pb: 2, mb: 2, borderBottom: '2px solid #E2E8F0', fontWeight: 700, fontSize: '0.875rem', color: '#64748B' }}>
                <Typography fontSize="inherit" fontWeight="inherit">Item</Typography>
                <Typography fontSize="inherit" fontWeight="inherit" textAlign="center">Price</Typography>
                <Typography fontSize="inherit" fontWeight="inherit" textAlign="center">Discounted Price</Typography>
                <Typography fontSize="inherit" fontWeight="inherit" textAlign="center">Qty</Typography>
                <Typography fontSize="inherit" fontWeight="inherit" textAlign="right">Total</Typography>
              </Box>
              {order.items && order.items.length > 0 ? (
                order.items.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
                      gap: 1,
                      py: 2,
                      px: 1.5,
                      mb: 1,
                      borderRadius: 2,
                      bgcolor: index % 2 === 0 ? '#F8FAFC' : 'transparent',
                      alignItems: 'center'
                    }}
                  >
                    <Typography fontWeight="600" fontSize="0.95rem" color="#1E293B">{item.medicine_name}</Typography>
                    <Typography fontWeight="600" fontSize="0.9rem" color="#64748B" textAlign="center">₹{Number(item.price).toFixed(2)}</Typography>
                    <Typography fontWeight="600" fontSize="0.9rem" color="#64748B" textAlign="center">₹{Number(item.discounted_price).toFixed(2)}</Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      <Chip
                        label={`×${item.quantity}`}
                        size="small"
                        sx={{ bgcolor: '#DBEAFE', color: '#1E40AF', fontWeight: 700, fontSize: '0.8rem', pointerEvents: 'none' }}
                      />
                    </Box>
                    <Typography fontWeight="700" fontSize="1rem" color="#0F172A" textAlign="right">₹{Number(item.total_price).toFixed(2)}</Typography>
                  </Box>

                ))
                
              ) : (
                <Box sx={{ textAlign: 'center', py: 6, color: '#94A3B8' }}>
                  <Typography>No items found</Typography>
                </Box>
              )}
              {prescriptionFiles.length > 0 && (
                          <Box sx={{ mb: 3 }}>
                            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, display: "flex", alignItems: "center", gap: 1 }}>
                              <FileIcon /> Prescription Files ({prescriptionFiles.length})
                            </Typography>
                            <Grid container spacing={2}>
                              {prescriptionFiles.map((file, idx) => (
                                <Grid item xs={12} sm={6} md={4} key={`prescription-${orderId}-${idx}`}>
                                  <FilePreview file={file} onClick={() => openFileDialog(file.url)} />
                                </Grid>
                              ))}
                            </Grid>
                            <Divider sx={{ my: 3 }} />
                          </Box>
                        )}
            </AccordionDetails>
          </Accordion>
        {order.return_items_history?.length > 0 && (
  <Accordion
    expanded={expanded === 'returns'}
    onChange={handleAccordionChange('returns')}
    sx={{
      mb: 2,
      borderRadius: '12px !important',
      boxShadow: '0 2px 8px rgba(34, 87, 122, 0.1)',
      '&:before': { display: 'none' }
    }}
  >
    <AccordionSummary
      expandIcon={<ExpandMore />}
      sx={{
        bgcolor: '#F8FAFC',
        borderBottom:
          expanded === 'returns'
            ? '1px solid #E2E8F0'
            : 'none',
        '&:hover': { bgcolor: '#EFF6FF' },
        minHeight: '64px'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Inventory sx={{ color: '#22577A', fontSize: 28 }} />

        <Box>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ color: '#22577A' }}
          >
            Return Information
          </Typography>

          <Typography
            variant="caption"
            color="text.secondary"
          >
            {order.return_items_history.length} returned item(s)
          </Typography>
        </Box>
      </Box>
    </AccordionSummary>

    <AccordionDetails sx={{ p: 3 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr 1fr',
          gap: 1,
          pb: 2,
          mb: 2,
          borderBottom: '2px solid #E2E8F0',
          fontWeight: 700,
          fontSize: '0.875rem',
          color: '#64748B'
        }}
      >
        <Typography fontSize="inherit" fontWeight="inherit">
          Item
        </Typography>

        <Typography
          fontSize="inherit"
          fontWeight="inherit"
          textAlign="center"
        >
          Returned Qty
        </Typography>

        <Typography
          fontSize="inherit"
          fontWeight="inherit"
          textAlign="center"
        >
          Refund Amount
        </Typography>

        <Typography
          fontSize="inherit"
          fontWeight="inherit"
          textAlign="right"
        >
          Status
        </Typography>
      </Box>

      {order.return_items_history.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: 'grid',
            gridTemplateColumns: '2fr 1fr 1fr 1fr',
            gap: 1,
            py: 2,
            px: 1.5,
            mb: 1,
            borderRadius: 2,
            bgcolor:
              index % 2 === 0
                ? '#F8FAFC'
                : 'transparent',
            alignItems: 'center'
          }}
        >
          <Typography
            fontWeight="600"
            fontSize="0.95rem"
            color="#1E293B"
          >
            {item.medicine_name}
          </Typography>

          <Typography
            fontWeight="600"
            fontSize="0.9rem"
            color="#64748B"
            textAlign="center"
          >
            {item.quantity}
          </Typography>

          <Typography
            fontWeight="600"
            fontSize="0.9rem"
            color="#64748B"
            textAlign="center"
          >
            ₹{Number(item.refunded_amount || 0).toFixed(2)}
          </Typography>

          <Box sx={{ textAlign: 'right' }}>
            <Chip
              label="Returned"
              size="small"
              sx={{
                bgcolor: '#FEE2E2',
                color: '#DC2626',
                fontWeight: 700,
                pointerEvents: 'none'
              }}
            />
          </Box>
        </Box>
      ))}
    </AccordionDetails>
  </Accordion>
)}
          
          {renderChildOrders()}

          {/* Delivery Address Accordion */}
          <Accordion
            expanded={expanded === 'delivery'}
            onChange={handleAccordionChange('delivery')}
            sx={{ mb: 2, borderRadius: '12px !important', boxShadow: '0 2px 8px rgba(34, 87, 122, 0.1)', '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              sx={{ bgcolor: '#F8FAFC', borderBottom: expanded === 'delivery' ? '1px solid #E2E8F0' : 'none', '&:hover': { bgcolor: '#EFF6FF' }, minHeight: '64px' }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <LocationOn sx={{ color: '#22577A', fontSize: 28 }} />
                <Box>
                  <Typography variant="h6" fontWeight="bold" sx={{ color: '#22577A' }}>Delivery Address</Typography>
                  <Typography variant="caption" color="text.secondary">{order.delivery_address.community_name}</Typography>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 3 }}>
              <Typography fontWeight="bold">{order.delivery_address.full_name}</Typography>
              <Typography color="#006D77" fontWeight="600" sx={{ my: 1 }}>{order.delivery_address.phone}</Typography>
              <Divider sx={{ my: 1, bgcolor: "#D1FAE5" }} />
              <Typography color="#006D77" fontWeight="600" sx={{ my: 1 }}>Community Name: {order.delivery_address.community_name}</Typography>
              <Typography>Block No: {order.delivery_address.address_line1}</Typography>
              <Typography>Flat No:{order.delivery_address.address_line2}</Typography>
              {/* {order.delivery_address.landmark && (
                <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic' }}>Near: {order.delivery_address.landmark}</Typography>
              )}
              <Typography>{order.delivery_address.city}, {order.delivery_address.state}</Typography>
              <Typography>PIN: {order.delivery_address.pincode}</Typography> */}
            <Typography>Delivery Option:{order.delivery_address.delivery_time_option}</Typography>
            <Typography>Delivery Time: {formatTimeToIso(order?.delivery_address?.delivery_time) || "N/A"}</Typography>

            </AccordionDetails>
          </Accordion>

          {renderIssuesSection()}

          {/* Payment Information Accordion */}
          <Accordion
            expanded={expanded === 'payment'}
            onChange={handleAccordionChange('payment')}
            sx={{ mb: 2, borderRadius: '12px !important', boxShadow: '0 2px 8px rgba(34, 87, 122, 0.1)', '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              sx={{ bgcolor: '#F8FAFC', borderBottom: expanded === 'payment' ? '1px solid #E2E8F0' : 'none', '&:hover': { bgcolor: '#EFF6FF' }, minHeight: '64px' }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Payment sx={{ color: '#22577A', fontSize: 28 }} />
                <Box>
                  <Typography variant="h6" fontWeight="bold" sx={{ color: '#22577A' }}>Payment Information</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {order.payment.method === 'online' ? 'Online Payment' : 'Cash on Delivery'}
                  </Typography>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography color="text.secondary">Payment Method</Typography>
                <Typography fontWeight="600">{order.payment.method === 'online' ? 'Online Payment' : 'Cash on Delivery'}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography color="text.secondary">Payment Status</Typography>
                <Chip
                  label={order.payment.status === 'success' ? 'Paid' : order.payment.status === 'failed' ? 'Failed' : 'Pending'}
                  size="small"
                  sx={{
                    bgcolor: order.payment.status === 'success' ? '#D1FAE5' : order.payment.status === 'failed' ? '#FEE2E2' : '#FEF3C7',
                    color: order.payment.status === 'success' ? '#059669' : order.payment.status === 'failed' ? '#DC2626' : '#D97706',
                    fontWeight: 'bold',
                    pointerEvents: 'none'
                  }}
                />
              </Box>
              {order.payment.payment_id && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography color="text.secondary">Payment ID</Typography>
                  <Typography variant="body2" sx={{ fontFamily: 'monospace', color: '#6B7280' }}>{order.payment.payment_id}</Typography>
                </Box>
              )}
            </AccordionDetails>
          </Accordion>

          {/* Patient Details Accordion */}
          <Accordion
            expanded={expanded === 'patient'}
            onChange={handleAccordionChange('patient')}
            sx={{ mb: 2, borderRadius: '12px !important', boxShadow: '0 2px 8px rgba(34, 87, 122, 0.1)', '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              sx={{ bgcolor: '#F8FAFC', borderBottom: expanded === 'patient' ? '1px solid #E2E8F0' : 'none', '&:hover': { bgcolor: '#EFF6FF' }, minHeight: '64px' }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Person sx={{ color: '#22577A', fontSize: 28 }} />
                <Box>
                  <Typography variant="h6" fontWeight="bold" sx={{ color: '#22577A' }}>Patient Details</Typography>
                  <Typography variant="caption" color="text.secondary">{order.patient_details?.name}</Typography>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 3 }}>
              {[
                ['Name', order.patient_details?.name],
                ['Age', order.patient_details?.age],
                ['Gender', order.patient_details?.gender],
                ['Phone', order.patient_details?.phone],
                ['Doctor Name', order.patient_details?.doctorname],
              ].map(([label, value], index) => (
                <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', py: 1.5, borderBottom: index < 4 ? '1px solid #E1E9F0' : 'none' }}>
                  <Typography color="text.secondary" fontSize={14}>{label}</Typography>
                  <Typography fontWeight="600" fontSize={14}>{value || '-'}</Typography>
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>

          {/* Price Details Accordion */}
          <Accordion
            expanded={expanded === 'price'}
            onChange={handleAccordionChange('price')}
            sx={{ mb: 2, borderRadius: '12px !important', boxShadow: '0 2px 8px rgba(34, 87, 122, 0.1)', '&:before': { display: 'none' } }}
          >
            <AccordionSummary
              expandIcon={<ExpandMore />}
              sx={{ bgcolor: '#F8FAFC', borderBottom: expanded === 'price' ? '1px solid #E2E8F0' : 'none', '&:hover': { bgcolor: '#EFF6FF' }, minHeight: '64px' }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Receipt sx={{ color: '#22577A', fontSize: 28 }} />
                <Box>
                  <Typography variant="h6" fontWeight="bold" sx={{ color: '#22577A' }}>Price Details</Typography>
                  <Typography variant="caption" color="text.secondary">Total: ₹{order.total_amount.toFixed(2)}</Typography>
                </Box>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 3, background: 'linear-gradient(to bottom, #F5FFEF, #ECF9E6)' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography color="text.secondary" fontSize={14}>Subtotal</Typography>
                <Typography fontWeight="600" fontSize={14}>₹{order.subtotal.toFixed(2)}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography color="text.secondary" fontSize={14}>Delivery Charge</Typography>
                <Typography fontWeight="600" fontSize={14}>
                  {order.delivery_charge === 0 ? (
                    <>
                      <span style={{ textDecoration: 'line-through', color: 'gray' }}>₹50</span>{' '}
                      <span style={{ color: '#0B8A2E' }}>₹0</span>
                    </>
                  ) : `₹${order.delivery_charge.toFixed(2)}`}
                </Typography>
              </Box>
              {order.subscription_discount > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                  <Box>
                    <Typography color="text.secondary" fontSize={14}>Subscription Discount</Typography>
                    {order.subscription_name && (
                      <Typography fontSize={11} sx={{ color: '#8B5CF6', fontStyle: 'italic' }}>{order.subscription_name}</Typography>
                    )}
                  </Box>
                  <Typography fontWeight="600" fontSize={14} color="#8B5CF6">-₹{order.subscription_discount.toFixed(2)}</Typography>
                </Box>
              )}
              {order.promo_discount > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                  <Box>
                    <Typography color="text.secondary" fontSize={14}>Promo Code Discount</Typography>
                    {order.promo_code && (
                      <Typography fontSize={11} sx={{ color: '#10B981', fontStyle: 'italic' }}>{order.promo_code}</Typography>
                    )}
                  </Box>
                  <Typography fontWeight="600" fontSize={14} color="#10B981">-₹{order.promo_discount.toFixed(2)}</Typography>
                </Box>
              )}
              {order.discount > 0 && (order.subscription_discount || 0) + (order.promo_discount || 0) < order.discount && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                  <Typography color="text.secondary" fontSize={14}>Other Discount</Typography>
                  <Typography fontWeight="600" fontSize={14} color="#0B8A2E">
                    -₹{(order.discount - (order.subscription_discount || 0) - (order.promo_discount || 0)).toFixed(2)}
                  </Typography>
                </Box>
              )}
              <Divider sx={{ my: 2 }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6" fontWeight="700" sx={{ color: '#225522' }}>Total</Typography>
                <Box sx={{ bgcolor: '#225522', color: '#fff', fontSize: 14, fontWeight: 700, px: 2.5, py: 0.7, borderRadius: 2 }}>
                  ₹{order.total_amount.toFixed(2)}
                </Box>
              </Box>
              {((order.subscription_discount || 0) + (order.promo_discount || 0)) > 0 && (
                <Box sx={{ mt: 2, p: 1.5, bgcolor: '#D1FAE5', borderRadius: 2, textAlign: 'center' }}>
                  <Typography fontSize={13} fontWeight="600" color="#059669">
                    🎉 You saved ₹{((order.subscription_discount || 0) + (order.promo_discount || 0)).toFixed(2)} on this order!
                  </Typography>
                </Box>
              )}
            </AccordionDetails>
          </Accordion>
                    {/* Feedback Accordion */}
                    {order.feedback && order.feedback.rating && (
            <Accordion
              expanded={expanded === 'feedback'}
              onChange={handleAccordionChange('feedback')}
              sx={{ mb: 2, borderRadius: '12px !important', boxShadow: '0 2px 8px rgba(34, 87, 122, 0.1)', '&:before': { display: 'none' } }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                sx={{ bgcolor: '#F8FAFC', borderBottom: expanded === 'feedback' ? '1px solid #E2E8F0' : 'none', '&:hover': { bgcolor: '#EFF6FF' }, minHeight: '64px' }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <RateReview sx={{ color: '#22577A', fontSize: 28 }} />
                  <Box>
                    <Typography variant="h6" fontWeight="bold" sx={{ color: '#22577A' }}>Your Feedback</Typography>
                    <Rating value={order.feedback.rating} readOnly size="small" />
                  </Box>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Rating value={order.feedback.rating} readOnly size="medium" />
                  <Typography sx={{ ml: 1, fontWeight: 600 }}>{order.feedback.rating}/5</Typography>
                </Box>
                {order.feedback.comment && (
                  <Typography color="text.secondary" sx={{ fontStyle: 'italic' }}>"{order.feedback.comment}"</Typography>
                )}
                {order.feedback.created_at && (
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                    Submitted on {formatDate(order.feedback.created_at)}
                  </Typography>
                )}
              </AccordionDetails>
            </Accordion>
          )}

          {/* Complaints Accordion */}
          {order.complaints && order.complaints.length > 0 && (
            <Accordion
              expanded={expanded === 'complaints'}
              onChange={handleAccordionChange('complaints')}
              sx={{ mb: 2, borderRadius: '12px !important', boxShadow: '0 2px 8px rgba(34, 87, 122, 0.1)', '&:before': { display: 'none' } }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                sx={{ bgcolor: '#F8FAFC', borderBottom: expanded === 'complaints' ? '1px solid #E2E8F0' : 'none', '&:hover': { bgcolor: '#EFF6FF' }, minHeight: '64px' }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <ReportProblem sx={{ color: '#D97706', fontSize: 28 }} />
                  <Box>
                    <Typography variant="h6" fontWeight="bold" sx={{ color: '#22577A' }}>Complaints History</Typography>
                    <Typography variant="caption" color="text.secondary">{order.complaints.length} complaint(s)</Typography>
                  </Box>
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ p: 3 }}>
                {order.complaints.map((complaint, index) => (
                  <Card key={index} sx={{ mb: 2, bgcolor: '#FEF3C7', borderLeft: '4px solid #D97706' }}>
                    <CardContent>
                      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Chip
                          label={complaint.category?.toUpperCase() || 'GENERAL'}
                          size="small"
                          sx={{ bgcolor: '#FBBF24', color: '#78350F', fontWeight: 'bold', pointerEvents: 'none' }}
                        />
                        <Chip
                          label={complaint.status?.toUpperCase() || 'PENDING'}
                          size="small"
                          sx={{
                            bgcolor: complaint.status === 'resolved' ? '#D1FAE5' : '#E0E7FF',
                            color: complaint.status === 'resolved' ? '#059669' : '#6366F1',
                            fontWeight: 'bold',
                            pointerEvents: 'none'
                          }}
                        />
                      </Box>
                      <Typography variant="body2" sx={{ mt: 1, color: '#78350F' }}>{complaint.description}</Typography>
                      {complaint.resolution && (
                        <Alert severity="success" sx={{ mt: 2 }}>
                          <Typography variant="body2" fontWeight="600">Resolution: {complaint.resolution}</Typography>
                        </Alert>
                      )}
                      {complaint.created_at && (
                        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                          Filed on {formatDate(complaint.created_at)}
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                ))}
              </AccordionDetails>
            </Accordion>
          )}
        </Box>

        {/* Action Buttons */}
        <Grid container spacing={2} sx={{ mt: 2, mb: 10 }}>
          {getActionButtons().map((button, index) => (
            <Grid item xs={12} sm={6} md={12 / getActionButtons().length} key={index}>
              {button.color === "error" ? (
                <Button fullWidth variant={button.variant} color={button.color} onClick={button.onClick} disabled={button.disabled} sx={button.sx}>
                  {button.label}
                </Button>
              ) : (
                <ButtonStyle fullWidth variant={button.variant} onClick={button.onClick} disabled={button.disabled} sx={button.sx}>
                  {button.label}
                </ButtonStyle>
              )}
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* All Dialogs remain the same */}
      <Dialog open={rescheduleDialog} onClose={() => setRescheduleDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 600, color: "#00796B", fontSize: "1.2rem", textAlign: "center" }}>
          Are you sure want to Reschedule order?
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2, fontWeight: 500, fontSize: "1.2rem" }}>Service: Medicine Order</Typography>
          <TextField
            label="Select New Date & Time"
            type="datetime-local"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={formData.date || ""}
            onChange={(e) => setFormData({ ...formData, date: e.target.value })}
            sx={{ mb: 2 }}
            inputProps={{ min: new Date().toISOString().slice(0, 16) }}
          />
          <TextField
            label="Reason for Rescheduling"
            fullWidth
            value={formData.reason || ""}
            onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
            sx={{ mb: 2 }}
            placeholder="e.g., Not available at home"
          />
          <TextField
            label="Additional Notes (Optional)"
            fullWidth
            multiline
            rows={3}
            value={formData.comment || ""}
            onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
            placeholder="Add any additional notes..."
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            onClick={() => {
              setRescheduleDialog(false);
              setFormData({ rating: 0, comment: "", category: "", date: "", reason: "" });
            }}
            sx={{ color: "#006D77", borderColor: "#006D77", textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ bgcolor: "#006D77", textTransform: "none", "&:hover": { bgcolor: "#004F56" } }}
            onClick={handleRescheduleOrder}
          >
            Confirm Reschedule
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={complaintDialog} onClose={() => setComplaintDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 600, color: "#00796B", fontSize: "1.2rem", textAlign: "center" }}>
          Raise a Complaint
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2, fontWeight: 500 }}>Service: Medicine Order</Typography>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Complaint Category</InputLabel>
            <Select
              value={formData.category || ""}
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              label="Complaint Category"
            >
              <MenuItem value="service delay">Service Delay</MenuItem>
              <MenuItem value="staff issue">Staff Issue</MenuItem>
              <MenuItem value="incomplete service">Incomplete Service</MenuItem>
              <MenuItem value="payment issue">Payment Issue</MenuItem>
              <MenuItem value="product quality">Product Quality</MenuItem>
              <MenuItem value="wrong item">Wrong Item Delivered</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Describe your complaint"
            fullWidth
            multiline
            rows={4}
            value={formData.comment || ""}
            onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
            placeholder="Please describe the issue in detail..."
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            onClick={() => {
              setComplaintDialog(false);
              setFormData({ rating: 0, comment: "", category: "", date: "", reason: "" });
            }}
            sx={{ color: "#006D77", borderColor: "#006D77", textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ bgcolor: "#006D77", textTransform: "none", "&:hover": { bgcolor: "#004F56" } }}
            onClick={handleComplaintSubmit}
          >
            Submit Complaint
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={feedbackDialog} onClose={() => setFeedbackDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 600, color: "#00796B", fontSize: "1.2rem", textAlign: "center" }}>
          Share Your Feedback
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2, fontWeight: 500 }}>Service: Medicine Order</Typography>
          <Typography sx={{ mb: 1, fontWeight: 600 }}>How was your experience?</Typography>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
            <Rating
              value={formData.rating || 0}
              size="large"
              onChange={(e, newValue) => setFormData({ ...formData, rating: newValue })}
            />
          </Box>
          <TextField
            label="Share your feedback"
            fullWidth
            multiline
            rows={4}
            value={formData.comment || ""}
            onChange={(e) => setFormData({ ...formData, comment: e.target.value })}
            placeholder="Write your experience with the service..."
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            onClick={() => {
              setFeedbackDialog(false);
              setFormData({ rating: 0, comment: "", category: "", date: "", reason: "" });
            }}
            sx={{ color: "#006D77", borderColor: "#006D77", textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{ bgcolor: "#006D77", textTransform: "none", "&:hover": { bgcolor: "#004F56" } }}
            onClick={handleFeedbackSubmit}
          >
            Submit Feedback
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={cancelDialog} onClose={() => setCancelDialog(false)}>
        <DialogTitle sx={{ fontWeight: 600, color: "#00796B", fontSize: "1.2rem", textAlign: "center" }}>
          Cancel Order
        </DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to cancel this order?</Typography>
          <TextField
            label="Reason for Cancellation"
            fullWidth
            multiline
            required
            rows={2}
            sx={{ mt: 2 }}
            value={cancelReason}
            onChange={(e) => setCancelReason(e.target.value)}
          />
          {order.payment?.method === "online" && order.payment?.status === "success" && (
            <Alert severity="info" sx={{ mt: 2 }}>Your payment will be refunded within 5-7 business days.</Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCancelDialog(false)} sx={{ textTransform: "none" }}>No, Keep Order</Button>
          <Button onClick={handleCancelOrder} color="error" variant="contained" sx={{ textTransform: "none" }} disabled={!cancelReason.trim()}>
            Yes, Cancel Order
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={contactDialog} onClose={() => setContactDialog(false)}>
        <DialogTitle sx={{ fontWeight: 600 }}>Contact Support</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 2 }}>Choose how you'd like to contact us</Typography>
          <Button fullWidth variant="outlined" startIcon={<Phone />} sx={{ mb: 2 }} onClick={() => window.open(`tel:+${call}`)} >
            Call Us: +91 {call}
          </Button>

          <Button fullWidth variant="outlined" startIcon={<Email />} onClick={() => window.open(`mailto:${email}`)}>
            Email: {email}
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setContactDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Dialog 
        open={reorderDialog} 
        onClose={() => !loading && setReorderDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 600, color: '#22577A', pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Inventory sx={{ fontSize: 28 }} />
            <Typography variant="h6" fontWeight="600">Reorder Items</Typography>
          </Box>
        </DialogTitle>
        
        <DialogContent>
          {loading ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
              <CircularProgress size={50} sx={{ color: '#006D77', mb: 2 }} />
              <Typography fontWeight="600" sx={{ mb: 1 }}>
                Checking stock availability...
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Please wait while we verify all items
              </Typography>
            </Box>
          ) : (
            <>
              <Alert severity="info" sx={{ mb: 3 }}>
                <Typography variant="body2" fontWeight="600" sx={{ mb: 0.5 }}>
                  Quick Reorder
                </Typography>
                <Typography variant="caption">
                  We'll verify stock availability before placing your order. Same items, same convenience!
                </Typography>
              </Alert>

              {order?.items && (
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1.5, color: '#22577A' }}>
                    Items to be ordered ({order.items.length}):
                  </Typography>
                  <Box sx={{ 
                    maxHeight: 250, 
                    overflowY: 'auto',
                    border: '1px solid #E2E8F0',
                    borderRadius: 2,
                    p: 1
                  }}>
                    {order.items.map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mb: 1,
                          p: 1.5,
                          bgcolor: index % 2 === 0 ? '#F8FAFC' : '#FFFFFF',
                          borderRadius: 1,
                          border: '1px solid #E2E8F0'
                        }}
                      >
                        <Box sx={{ flex: 1 }}>
                          <Typography variant="body2" fontWeight="600" sx={{ color: '#1E293B' }}>
                            {item.medicine_name}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            ₹{Number(item.price).toFixed(2)} per unit
                          </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Chip 
                            label={`Qty: ${item.quantity}`}
                            size="small"
                            sx={{ 
                              bgcolor: '#DBEAFE', 
                              color: '#1E40AF', 
                              fontWeight: 700,
                              fontSize: '0.75rem'
                            }}
                          />
                          <Typography variant="body2" fontWeight="700" sx={{ minWidth: 60, textAlign: 'right' }}>
                            ₹{Number(item.total_price).toFixed(2)}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}

              {/* Order Summary */}
              <Box sx={{ 
                mt: 2, 
                p: 2, 
                bgcolor: '#F0F9FF', 
                borderRadius: 2,
                border: '1px solid #BFDBFE'
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2" color="text.secondary">Subtotal:</Typography>
                  <Typography variant="body2" fontWeight="600">
                    ₹{order?.subtotal?.toFixed(2)}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2" color="text.secondary">Delivery Charge:</Typography>
                  <Typography variant="body2" fontWeight="600" color="#0B8A2E">
                    {order?.delivery_charge === 0 ? 'FREE' : `₹${order?.delivery_charge?.toFixed(2)}`}
                  </Typography>
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="body1" fontWeight="700">Estimated Total:</Typography>
                  <Typography variant="body1" fontWeight="700" sx={{ color: '#22577A' }}>
                    ₹{order?.total_amount?.toFixed(2)}
                  </Typography>
                </Box>
              </Box>

              {/* Delivery Address Preview */}
              {order?.delivery_address && (
                <Box sx={{ mt: 2, p: 2, bgcolor: '#F8FAFC', borderRadius: 2, border: '1px solid #E2E8F0' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                    <LocationOn sx={{ fontSize: 18, color: '#22577A' }} />
                    <Typography variant="caption" fontWeight="700" sx={{ color: '#22577A' }}>
                      DELIVERY ADDRESS
                    </Typography>
                  </Box>
                  <Typography variant="body2" fontWeight="600">
                    {order.delivery_address.full_name}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {order.delivery_address.community_name}, Block {order.delivery_address.address_line1}, 
                    Flat {order.delivery_address.address_line2}
                  </Typography>
                </Box>
              )}



{/* NEW: Delivery Time Selection */}
<Box sx={{ mt: 3, mb: 2 }}>
        <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1.5, color: '#22577A' }}>
          Preferred Delivery Time <span style={{ color: '#DC2626' }}>*</span>
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <Button
            variant={reorderDeliveryTime === "anytime" ? "contained" : "outlined"}
            onClick={() => {
              setReorderDeliveryTime("anytime");
              setReorderSelectedDate("");
              setReorderSelectedSlot("");
              setReorderAvailableSlots([]);
              setReorderErrors({});
            }}
            sx={{
              flex: 1,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 600,
              borderColor: '#006D77',
              color: reorderDeliveryTime === "anytime" ? '#fff' : '#006D77',
              bgcolor: reorderDeliveryTime === "anytime" ? '#006D77' : 'transparent',
              '&:hover': {
                bgcolor: reorderDeliveryTime === "anytime" ? '#004F55' : '#F0F9FF',
                borderColor: '#006D77'
              }
            }}
          >
            Anytime
          </Button>
          <Button
            variant={reorderDeliveryTime === "specific" ? "contained" : "outlined"}
            onClick={() => {
              setReorderDeliveryTime("specific");
              setReorderErrors({});
            }}
            sx={{
              flex: 1,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 600,
              borderColor: '#006D77',
              color: reorderDeliveryTime === "specific" ? '#fff' : '#006D77',
              bgcolor: reorderDeliveryTime === "specific" ? '#006D77' : 'transparent',
              '&:hover': {
                bgcolor: reorderDeliveryTime === "specific" ? '#004F55' : '#F0F9FF',
                borderColor: '#006D77'
              }
            }}
          >
            Specific Time
          </Button>
        </Box>

        {/* Date and Time Selection - Show when Specific Time is selected */}
        {reorderDeliveryTime === "specific" && (
          <>
            <TextField
              type="date"
              fullWidth
              label="Select Delivery Date"
              value={reorderSelectedDate}
              onChange={(e) => handleReorderDateChange(e.target.value)}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                min: new Date().toISOString().split("T")[0],
                max: (() => {
                  const maxDate = new Date();
                  maxDate.setDate(maxDate.getDate() + 10);
                  return maxDate.toISOString().split("T")[0];
                })()
              }}
              error={!!reorderErrors.date}
              helperText={reorderErrors.date}
              sx={{ 
                mb: 2,
                '& input': { cursor: 'pointer' }
              }}
              onKeyDown={(e) => e.preventDefault()}
              onClick={(e) => e.currentTarget.querySelector('input').showPicker()}
            />

            {reorderSelectedDate && reorderAvailableSlots.length > 0 && (
              <Box>
                <Typography variant="body2" fontWeight="600" sx={{ mb: 1.5, color: '#374151' }}>
                  Available Time Slots <span style={{ color: '#DC2626' }}>*</span>
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {reorderAvailableSlots.map((slot, index) => (
                    <Button
                      key={index}
                      variant={reorderSelectedSlot === slot.label ? "contained" : "outlined"}
                      disabled={slot.disabled}
                      onClick={() => {
                        setReorderSelectedSlot(slot.label);
                        setReorderErrors({ ...reorderErrors, time: "" });
                      }}
                      sx={{
                        py: 1.5,
                        textTransform: 'none',
                        fontWeight: 600,
                        justifyContent: 'flex-start',
                        borderColor: reorderSelectedSlot === slot.label ? '#006D77' : '#D1D5DB',
                        bgcolor: slot.disabled ? '#F3F4F6' : reorderSelectedSlot === slot.label ? '#006D77' : 'transparent',
                        color: slot.disabled ? '#9CA3AF' : reorderSelectedSlot === slot.label ? '#fff' : '#374151',
                        cursor: slot.disabled ? 'not-allowed' : 'pointer',
                        '&:hover': {
                          bgcolor: slot.disabled ? '#F3F4F6' : reorderSelectedSlot === slot.label ? '#004F55' : '#F0F9FF',
                          borderColor: slot.disabled ? '#D1D5DB' : '#006D77'
                        }
                      }}
                    >
                      ⏱ {slot.label} {slot.disabled && "(Unavailable)"}
                    </Button>
                  ))}
                </Box>
                {reorderErrors.time && (
                  <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                    {reorderErrors.time}
                  </Typography>
                )}
              </Box>
            )}
          </>
        )}

        {/* Display selected delivery time */}
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
          <strong>Delivery Time:</strong>{" "}
          {reorderDeliveryTime === "anytime" 
            ? "Anytime" 
            : reorderSelectedSlot 
              ? `${reorderSelectedDate} | ${reorderSelectedSlot}`
              : "Not selected"}
        </Typography>
      </Box>



              {/* Payment Info */}
              <Alert severity="warning" sx={{ mt: 2 }}>
                <Typography variant="caption">
                  <strong>Payment:</strong> You'll be redirected to payment gateway after stock verification is complete.
                </Typography>
              </Alert>
            </>
          )}
        </DialogContent>
        
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button 
            onClick={() => setReorderDialog(false)}
            disabled={loading}
            sx={{ 
              textTransform: 'none',
              color: '#64748B',
              '&:hover': { bgcolor: '#F1F5F9' }
            }}
          >
            Cancel
          </Button>
          <ButtonStyle
            variant="contained"
            sx={{ 
              bgcolor: '#006D77',
              px: 3,
              '&:disabled': {
                bgcolor: '#94A3B8',
                color: '#FFFFFF'
              }
            }}
            onClick={handleReorderSubmit}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} sx={{ color: '#FFFFFF' }} /> : null}
          >
            {loading ? 'Verifying Stock...' : 'Confirm Reorder'}
          </ButtonStyle>
        </DialogActions>
      </Dialog>
      <Footer />
      <CustomDialog open={dialogOpen} message={dialogMessage} type="success" title="Success" onClose={() => setDialogOpen(false)} />

    </Box>
    
  );
};

export default OrderDetailsScreen;